import script from "./FixtureOverviewOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./FixtureOverviewOdd.vue?vue&type=script&setup=true&lang=js"

import "./FixtureOverviewOdd.vue?vue&type=style&index=0&id=609acda0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-609acda0"]])

export default __exports__